import styles from './AddStudyPlan.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import { TextInput, TextInputValue } from 'src/components/text-input/TextInput';
import { useCallback, useEffect, useState } from 'react';
import Spinner from '@src/components/spinner/Spinner';
import { StudyPlanContentFragment } from '@src/api/graphql-codegen';
import RemoveIcon from 'src/assets/icons/study-remove.svg?react';

type Props = {
  open: boolean;
  creating: boolean;
  studyPlan?: StudyPlanContentFragment;
  studyPlans: StudyPlanContentFragment[];
  onClose: () => void;
  onUpdateStudyPlan: (id: string, name: string, unitId?: string) => void;
  onRemoveStudyPlan?: (id: string) => void;
  unitId?: string;
};

function EditStudyPlan(props: Props) {
  const { open, creating, studyPlan, studyPlans, onClose, onUpdateStudyPlan, onRemoveStudyPlan, unitId } = props;
  const [ name, setName ] = useState(studyPlan?.name ?? "")
  const [ error, setError ] = useState("")


  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    const onPageLoad = () => {
      const item = document.getElementById("name")
      if (item) {
        item.focus();
      }
    };
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      return () => window.removeEventListener('load', onPageLoad);
    }

  }, [])

  const handleChange = (value: TextInputValue) => {
    setName(value.toString())
    setError('')
  }
  const handleUpdateNew = useCallback(() => {
    if (studyPlan && name) {
      if (name === studyPlan?.name) {
        onClose();
        return;
      }
      const exist = studyPlans.find(plan => plan.name.toLocaleLowerCase() === name.toLocaleLowerCase())
      if (exist) {
        setError(`${name} is exist already, Study Plan name should be unique.`)
        return;
      }
      unitId ? onUpdateStudyPlan(studyPlan.id, name, unitId) : onUpdateStudyPlan(studyPlan.id, name)
    }
  }, [studyPlan, name, studyPlans, unitId, onUpdateStudyPlan, onClose])

  const handleRemoveStudyPlan = useCallback(() => {
    if (studyPlan && onRemoveStudyPlan) {
      onRemoveStudyPlan(studyPlan.id);
    }
  }, [studyPlan, onRemoveStudyPlan])


  return (
    <Modal open={open} onClose={handleClose} className={styles.editWrapper}>
      <div>
        <div className={styles.title}>{studyPlan?.name === "" ? 'Name this Study Plan' : 'Edit Study Plan'}</div>
        <div className={styles.content}>
          <TextInput hasError={error!==''} subTitle={error} id="name" placeholder={studyPlan?.name === "" ? 'No name' :'Study plan name'} value={name} label={studyPlan?.name === "" ? '' : 'Study Plan Name'} onChange={handleChange} />
          { studyPlan?.name === "" ?
          <div className={styles.editAction}>
            <Button disabled={creating || (!studyPlan && !name)} size="small" leftIcon={creating ? <Spinner width={20} height={20} /> : undefined} className={styles.okButton} onClick={handleUpdateNew} label={'OK'}/>
          </div> :
          <div className={styles.editAction}>
            <Button disabled={false} size="small" leftIcon={creating ? <Spinner width={20} height={20} /> : <RemoveIcon width={14} height={14} />} className={styles.removeButton} onClick={handleRemoveStudyPlan} label={'Remove Study Plan'}/>
            <Button disabled={creating || !name} size="small" leftIcon={creating ? <Spinner width={20} height={20} /> : undefined} className={styles.okButton} onClick={handleUpdateNew} label={'SAVE'}/>
          </div>}
        </div>
      </div>
    </Modal>
  );
}

export default EditStudyPlan;
